export class RewardsPageVisitedEvent {
  /**
   * Static property for the event type
   * @return {string} The event type identifier
   */
  static get type() {
    return 'rewardsPageVisited'
  }

  /**
   * Creates a new RewardsPageVisitedEvent
   * @param {Object} params - The event parameters
   * @param {string} [params.pageType] - The type of page being viewed (optional)
   * @param {Array} [params.klasses] - The list of classes (optional)
   */
  constructor({ pageType = null, klasses = [] }) {
    this.pageType = pageType
    this.klasses = klasses
  }

  /**
   * Converts the event to a plain object for serialization
   * @return {Object} The event as a plain object
   */
  toObject() {
    return {
      pageType: this.pageType,
      klasses: this.klasses,
    }
  }
}
